import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';

const typeStyles = {
  primary: {
    surface: 'bg-cs-navy-600 rounded-cs-10 shadow-lg',
    heading: 'text-white',
    body: 'text-white'
  },
  inverted: {
    surface: 'bg-transparent',
    heading: 'text-cs-gray-900',
    body: 'text-cs-gray-900'
  },
  alt: {
      surface: 'bg-[#4E5A20]/10 rounded-cs-10 shadow-lg',
      heading: 'text-[#4E5A20]',
      body: 'text-[#4E5A20]'
  }
};

const typeDefaults = {
  primary: {
    heading: 'Ready to get involved?',
    body: "Create your free account on the CommunityShare platform to read the full project details. If you're interested, you'll be able to connect directly with the educator though the platform to ask questions and talk about scheduling. You'll also find more projects like this one waiting for partners like you!",
    buttonLabel: 'Create your free account'
  },
  inverted: {
    heading: 'Interested but not quite ready to sign up?',
    body: 'No problem! Complete a quick form and someone from our team will reach out to answer the questions you have.',
    buttonLabel: 'Express interest'
  }
};

CtaGroup.propTypes = {
  type: PropTypes.oneOf(Object.keys(typeStyles)),
  heading: PropTypes.node,
  body: PropTypes.node,
  buttonLabel: PropTypes.node,
  onButtonClick: PropTypes.func,
  primaryHref: PropTypes.string,
};

export default function CtaGroup(props) {
  const {
    type = 'primary',
    heading,
    body,
    buttonLabel,
    onButtonClick,
    primaryHref
  } = props;

  const t = typeStyles[type] ?? typeStyles.primary;
  const d = typeDefaults[type] ?? typeDefaults.primary;

  const headingText = heading ?? d.heading;
  const bodyText = body ?? d.body;
  const label = buttonLabel ?? d.buttonLabel;

  return (
    <section className={classNames('w-full max-w-screen-xl mx-auto px-6 py-6 flex flex-col', t.surface)}>
      <h2 className={classNames(t.heading, 'font-semibold text-3xl leading-tight')}>
        {headingText}
      </h2>
      <p className={classNames('mt-3 font-normal text-base leading-tight', t.body)}>
        {bodyText}
      </p>
      <div className="mt-6 flex justify-stretch md:justify-end">
        {type === 'inverted' && <SecondaryButton onClick={onButtonClick}>{label}</SecondaryButton>}
        {type === 'primary' && <PrimaryButton variant="inverted" href={primaryHref} onClick={onButtonClick}>{label}</PrimaryButton>}
        {type === 'alt' && <SecondaryButton href={primaryHref} onClick={onButtonClick}>{label}</SecondaryButton>}
      </div>
    </section>
  );
}
